import { render, staticRenderFns } from "./DeptAdd.vue?vue&type=template&id=06d17f18&scoped=true&"
import script from "./DeptAdd.vue?vue&type=script&lang=js&"
export * from "./DeptAdd.vue?vue&type=script&lang=js&"
import style0 from "./DeptAdd.vue?vue&type=style&index=0&id=06d17f18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d17f18",
  null
  
)

export default component.exports